import React, { useContext, useCallback, useState }  from "react";
import { StyleSheet, View, Text, TextInput }                    from "react-native";

import Row                                           from "~/layouts/Row";
import Col                                           from "~/layouts/Col";
import Heading                                       from "~/components/Heading";
import ExpandableCard                                from "~/components/ExpandableCard";

import ParticipantContext                            from "~/contexts/ParticipantContext";

export default function ParticipantNotes() {
  const { customer, getCustomer , loadingCustomer} = useContext(ParticipantContext);
  const { notes } = customer || {};

  if (!customer) return null;

  return (
    <ExpandableCard
      title="Notes"
      badge={!!notes}
      icon="file-text"
      onOpen={getCustomer}
      loading={loadingCustomer}
    >
      <Text>{ notes }</Text>
    </ExpandableCard>
  );
}

const styles = StyleSheet.create({
});
